import { makeStyles } from '@mui/styles';

const useStyles: any = makeStyles({
  actionIcon: {
    "&hover": {
      backgroundColor: "white",
    },
  },
  title: {
    backgroundColor: "rgb(236,235,239)",
    borderBottom: "1px solid rgba(0, 0, 0, 0.54)",
    padding: "4px 24px",
  },
  titleContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  closeIcon: {
    width: "24px",
    height: "24px",
  },
  dialogContent: {
    margin: "1rem",
    overflowY: "auto",
  },
  agreeBtn: {
    backgroundColor: "rgba(41, 19, 46, 0.95)",
    color: "white",
    paddingLeft: "2rem",
    paddingRight: "2rem",
    border: "1px solid rgba(41, 19, 46, 0.95)",
    borderRadius: "3px",
    marginRight: ".5rem",
    "&:hover": {
      backgroundColor: "rgba(41, 19, 46, 0.95)",
      color: "white",
    },
  },
  closeBtn: {
    color: "rgba(41, 19, 46, 0.95)",
    backgroundColor: "white",
    paddingLeft: "2rem",
    paddingRight: "2rem",
    marginLeft: ".5rem",
    "&:hover": {
      color: "rgba(41, 19, 46, 0.95)",
      backgroundColor: "white",
    },
  },
  dialogActions: {
    display: "flex",
    justifyContent: "center",
  },
  btn: {
    padding: "1rem",
  },
  "& select + &label": {
    "padding-left": ".5rem",
  },
  select: {
    "& select + &label": {
      "padding-left": ".5rem",
    },
  },

  actionBtnContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  imgContainer: {
    paddingRight: "20%",
    display: "flex",
    justifyContent: "center",
  },
  modalActions: {
    marginTop: "1rem",
    display: "flex",
    justifyContent: "flex-end",
  },
  inputFieldWithLabel: {
    "& input": {
      padding: "14px",
    },
    "& div": {
      marginTop: "0px",
      "& div": {
        "& div": {
          padding: "14px 14px",
        },
      },
    },
    "&>div": {
      marginBottom: "1rem",
    },
  },
  svgIcon: {
    "&span>svg:active": {
      color: "black",
    },
  },
  overWriteIcon: {
    "&:hover": {
      borderRadius: "0",
    },
  }
});
export default useStyles;
